import { Controller, useForm, useWatch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod/v4";
import { useFieldArray } from "react-hook-form";
import { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";

import ReactJson from "react-json-view";
import FormSelect from "../shared/FormSelect";
import FormInputText from "../shared/FormInputText";
import { FaRegTrashCan } from "react-icons/fa6";
import { fetchCreateGroups } from "../../utils/apiUtils";
import { loadTags } from "../../utils/optionLoaderUtils";

const CreateGroup = ({ createSuccessHandler }) => {
    const [errorMessage, setErrorMessage] = useState()
    const groupSchema = z.object({
        groupName: z.string().min(1, 'Group name is required'),
        desc: z.string().optional(),
        tags: z.array(z.object({ label: z.string(), value: z.string() })).optional(),
        users: z.array(z.object({ email: z.string().optional() })).optional(),
    });
    const {
        watch,
        control,
        register,
        formState: { errors, isValid, isDirty, dirtyFields, isSubmitting, isSubmitSuccessful },
        getValues,
        handleSubmit,
    } = useForm({
        resolver: zodResolver(groupSchema),
        defaultValues: {
            users: [],
            tags: [],
        },
        mode: "onSubmit"
    });

    const { fields: usersFields, remove, insert, append } = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormProvider)
        name: "users", // unique name for your Field Array
    });

    const onSubmit = async (values) => {
        setErrorMessage();
        const payload = { ...values, tags: values.tags?.map(({ value }) => value) }
        await fetchCreateGroups(payload)
        createSuccessHandler(false)
    }

    return (
        <div style={{ width: '100%', padding: '1rem' }}>
            <p className="title">Create group</p>
            <p className="sub-title">Collection of users that has tags that will be used to send alerts</p>

            <form onSubmit={handleSubmit(onSubmit)} className="form" style={{ paddingTop: '3rem' }}>

                <FormInputText label={'Group name'} name="groupName" register={register} errors={errors} placeholder="Group name..." />
                <FormInputText type={'textarea'} label={'Description'} name="desc" register={register} errors={errors} />

                <br />
                <p style={{ fontSize: '1.2rem', fontWeight: 600, padding: '2rem 0rem 1rem 0rem' }}>Tags</p>
                <div className="form-input">
                    <label style={{ display: "block" }}>Tags</label>
                    <Controller
                        control={control}
                        name={`tags`}
                        render={({ field, value, name, ref }) => {
                            return (
                                <AsyncPaginate
                                    debounceTimeout={300}
                                    name={field.name}
                                    inputRef={field.ref}
                                    classNamePrefix={"react-select"}
                                    value={watch('tags')}
                                    onChange={async (val) => {
                                        field.onChange(val);
                                    }}
                                    isMulti={true}
                                    loadOptions={(search) => loadTags(search, {})}
                                />
                            );
                        }}
                    />
                    {errors["account.value"] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors["account.value"]?.message}</p>}
                </div>

                {usersFields && <p style={{ fontSize: '1.2rem', fontWeight: 600, padding: '2rem 0rem 1rem 0rem' }}>Users</p>}
                {usersFields.map((field, index) => (
                    <div key={field.id} style={{ padding: '1rem 0rem 0rem 0rem', display: 'flex', gap: '1rem', justifyContent: 'center', alignItems: 'center' }}>

                        <FormInputText label={'Email'} name={`users.${index}.email`} register={register} errors={errors} placeholder="Email" />
                        {/* <FormInputText label={'Value'} name={`user.${index}.value`} register={register} errors={errors} placeholder="Value" /> */}

                        <FaRegTrashCan style={{ cursor: 'pointer', width: '10%' }} size={"1.2rem"} color={"var(--red)"} onClick={() => remove(index)} />


                    </div>
                ))}

                {isValid && <div style={{ padding: '0rem 0rem 3rem 0rem' }}>
                    <button type="button" onClick={() => append({ email: '', })} className="btn outline-btn">
                        Add user
                    </button>
                </div>}

                {errorMessage && <p className="danger" style={{ padding: '0rem 0rem 2rem 0rem' }}>{errorMessage}</p>}

                {isSubmitting ? <div className="loader" /> : <input
                    className="btn"
                    type="submit"
                    disabled={Object.keys(dirtyFields).length && !isValid}
                    value={'Create'} />}

                {/* <ReactJson
                    style={{ padding: "1rem" }}
                    src={{ form: watch(), dirtyFields }}
                    name={false}
                    collapsed={false}
                    collapseStringsAfterLength={150}
                    displayDataTypes={false}
                    displayObjectSize={false}
                    sortKeys={false}
                /> */}

            </form>
        </div>
    )
}

export default CreateGroup